import { progressStateComponentSiteCoreKeys } from "../../pages/manageBulkProcess/siteCore/SiteCoreKeys";

export const API_TIMEOUT_LIMIT = 60000; /**1min */
export const API_MAX_CONTENT_LENGTH = 2000;
export const TOAST_AUTO_HIDE_DURATION = 4000;
export const MAX_SAVE_FILTERS_LIMIT = 10;
export const FORM_ERROR_TIMEOUT_SHORT = 100;
export const FORM_ERROR_TIMEOUT_LONG = 1000;
export const TIMEOUT_100 = 100;
export const TIMEOUT_200 = 200;
export const EMPTY_VALUE_DASH = "--";
export const MAX_SCHEDULES_LIMIT = 6;
export const MAX_MILESTONES_LIMIT = 6;
export const ONE_DAY_IN_MS = 86400000;
export const TEXT_TO_REPLACE_REQUIRED_LABEL_NAME = "#LABELNAME#";
export const ONE_MB_IN_BYTES = 1024 * 1024;
export const MAX_PERCENTAGE = 100;
export const TIMEOUT_300 = 300;
export const ZERO = "0";
export const DEBOUNCE_THRESHOLD = 3;
export const DEBOUNCE_THRESHOLD_CLIENT = 2;

export const DEFAULT_TOOLTIPS_BILLING_AMOUNT = "0.00";
export const AMOUNT_INPUT_MAX_LENGTH = 13;

export const EXCHANGE_RATE_FIELD_MAX_DIGITS_ALLOWED = 6;

export const labelKey = "label";
export const chipKey = "chip";
export const viewMoreKey = "viewMore";

export const BRACKETS = {
  LEFT_SQUARE: "[",
  RIGHT_SQUARE: "]",
};

export const SYMBOL = {
  PLUS: "+",
  MINUS: "-",
  PIPE: "|",
  PERCENTAGE: "%",
};

export const EMPTY_OBJECT = {
  label: "",
  key: "",
  value: "",
  replaceEmptyWithDash: false,
};

export const DATE_FORMAT = {
  DD_MM_YYYY_SLASH: "DD/MM/YYYY",
  YYYY_MM_DD_HYPHEN: "YYYY-MM-DD",
  MMMM_YYYY: "MMMM, YYYY",
  MMM_YYYY_SLASH: "MMM / YYYY",
  DD_MMM_YYYY_HHMMSS_UNDERSCORE: "DD_MMM_YYYY_HHmmss",
  UTC_FORMAT: "YYYY-MM-DDTHH:mm:ss[Z]",
  LOCAL_FORMAT: "YYYY-MM-DDTHH:mm:ss",
  TIME_HOUR_MINUTE_12H: "hh:mm A",
  YYYY_MM_DD_HH_MM_SS_DASH: "YYYY_MM_DD_HH_mm_ss",
  DD_MMM_YYYY: "DD MMM YYYY",
};

export const getCustomDateFormatWithTime = (dateFormat: string = "") => {
  return `${dateFormat} | ${DATE_FORMAT.TIME_HOUR_MINUTE_12H}`;
};

export const getCustomDateFormatWithTimeBasedOnUserFormat = (
  userDateFormat: string = "",
) => {
  return `${userDateFormat} ${DATE_FORMAT.TIME_HOUR_MINUTE_12H}`;
};

export const TIMEZONE_STANDARD_CODES = {
  IANA: "iana",
};

export const DATE_TIME_CONSTANT = {
  HOUR: "h",
  MINUTE: "m",
} as const;

export const LANGUAGE_CODE = {
  EN_US: "en-US",
  EN_GB: "en-GB",
  FR_FR: "fr-FR",
  PT_BR: "pt-BR",
  JA_JP: "ja-JP",
};

export const SITE_CORE_COUNTRIES_VALUE = {
  FRANCE: "country.fr",
  SPAIN: "country.es",
  NETHERLANDS: "country.nl",
  JAPAN: "country.jp",
  KOREA_DEMOCRATIC: "country.kp",
  KOREA_REPUBLIC: "country.kr",
  AUSTRALIA: "country.au",
  INDIA: "country.in",
  NEW_ZEALAND: "country.nz",
  BANGLADESH: "country.bd",
  SRI_LANKA: "country.lk",
  COUNTRY_BELGIUM: "country.be",
  BRAZIL: "country.br",
  UNITED_STATES: "country.us",
  CANADA: "country.ca",
  ITALY: "country.it",
  BELGIUM: "country.be",
  MEXICO: "country.mx",
};

export const PATTERN = {
  SIRET_NUMBER: "||| ||| ||| ||||",
};

export const BUSINESS_IDENTIFIERS = {
  siretNumber: "Siret Number",
  btwNummer: "Btw-Nummer",
  nif: "NIF",
  abnNumber: "ABN Number",
  nzbn: "NZBN",
  qualifiedInvoiceNumber: "Qualified Invoice Number",
  cin: "CIN",
  bin: "BIN",
  tin: "TIN",
};

export const DOCUMENT_SITE_CORE_KEY = {
  cancellationReasonOther: "CancellationReason.Other",
  documentTypeContract: "DocumentType.Contract",
  documentTypeOthers: "DocumentType.Others",
  documentArchiveReasonOther: "ArchiveReason.Other",
};

export const CLIENT_DOCUMENT_TYPES = {
  clientContract: "client_contract",
  clientOthers: "client_others",
};

export const DOCUMENT_ORIGIN = {
  manual: "DocumentOrigin.Manual",
  inherited: "DocumentOrigin.Inherited",
};

export const BILLING_DETAILS_SITE_CORE_VALUE = {
  billingTypeMilestone: "BillingType.MilestoneBasedBilling",
  billingTypeImmediateBilling: "BillingType.ImmediateBilling",
  billingTypeSchedule: "BillingType.ScheduleBasedBilling",
  billingTypeActivity: "BillingType.ActivityBasedBilling",
  schedulePeriodMonthly: "SchedulePeriod.Monthly",
  schedulePeriodWeekly: "SchedulePeriod.Weekly",
  valueAmount: "Value.Amount",
  valuePercentage: "Value.Percentage",
};

export const BILLING_TYPE = {
  MILESTONE: "Milestone",
  IMMEDIATE: "Immediate",
  SCHEDULE: "Schedule",
  ACTIVITY: "Activity",
};

export const SAVED_SEARCH_PAGE_NAME = {
  CLIENT_SEARCH: 0,
  PROGRAM_SEARCH: 2,
  INDIVIDUAL_SEARCH: 3,
  NIS_PARTICIPANT_SEARCH: 12,
  COACH_PORTAL_MY_CASE_LOADS_SEARCH: 8,
  COACH_PORTAL_ALL_PARTICIPANTS_SEARCH: 9,
  PROJECT_SEARCH: 11,
  GENERIC_PARTICIPANT_SEARCH: 10,
};

export const PHONE_DEFAULT_VALUE = {
  DEFAULT_COUNTRY_CODE: "+1",
  DEFAULT_ISO_CODE: "us",
  DEFAULT_SELECT_CODE: "select",
};

export const DUPLICATE_DATA_VALUES = {
  CLIENT_SPECIFIC_RESOURCE: "ClientSpecificResource",
  CLIENT_SPECIFIC_PROGRAM_TEMPLATE: "ClientSpecificProgramTemplate",
  BILLING_CONFIGURATION: "BillingConfiguration",
  PROGRAM_TEMPLATE: "ProgramTemplate",
};

export type DuplicateDataTypes =
  (typeof DUPLICATE_DATA_VALUES)[keyof typeof DUPLICATE_DATA_VALUES];

export const PROGRAM_CLOSURE_LANDED_SUCCESSFULLY_ID =
  "e38bae1b-868d-4387-9c7b-427f392f3898";

export const PROGRAM_CLOSURE_LANDED_SUCCESSFULLY_SITECORE_KEY =
  "LandedSuccessfully";

export const PROGRAM_CLOSURE_PROGRAM_WITHDRAWN_SITECORE_KEY =
  "ProgramWithdrawn";

export const SOLUTION_OFFERING_CMC_SITECORE_KEY = "SolutionOfferings.CMC";

export const SOLUTION_OFFERING_OP_SITECORE_KEY =
  "SolutionOfferings.Outplacement";

export const TM_INDIVIDUAL_ASSESSMENT = "IndividualAssessment";
export const TM_LEADER_COACHING = "LeaderCoaching";

export const STATUS_UNSPECIFIED_SITECORE_KEY =
  "OutreachEligibility.StatusUnspecified";

export const RANGE_VALIDATION = {
  ONE: 1,
  HUNDRED: 100,
};

export const CLIENT_TYPE_SITE_CORE_VALUES = {
  AFFILIATE_CLIENT: "ClientType.AffiliateClient",
  RETAIL_CLIENT: "ClientType.RetailClient",
  STANDARD_CLIENT: "ClientType.StandardClient",
  NON_CLIENT_BILLING_PARTY: "ClientType.NonClientBillingParty",
} as const;

export type ClientTypeEnum =
  (typeof CLIENT_TYPE_SITE_CORE_VALUES)[keyof typeof CLIENT_TYPE_SITE_CORE_VALUES];

export const GENERIC_ACCOUNT_PURPOSE_LIST_SITE_CORE_VALUES = {
  CLIENT: "Purpose.Client",
  TEST_ACCESS: "Purpose.TestAccess",
  DEMO: "Purpose.Demo",
};

export const GENERIC_ACCOUNT_FEATURE_TYPES = {
  TOOL: "Tool",
  ASSESSMENT: "Assessment",
  EVENTS_PAGE: "EventsPage",
  DOCEBO_TILE: "DoceboTile",
  MY_COACH_PAGE: "MyCoachPage",
};

export const GENERIC_ACCOUNT_NAVIGATION_FROM = {
  VIEW: "view",
  SEARCH: "search",
};

export const GENERIC_ACCOUNT_PARTICIPANT_NAVIGATION_FROM = {
  REGISTERED_PARTICIPANT_RESULT_PAGE: "registered-participant-result",
  VIEW_PARTICIPANT_PAGE: "view-participant",
};

export const gridSizeLongLabel = { xs: 12, md: 8 }; // This is used in cases where we want the label to be long and take more space than the input field. For example, in MDM Create Office page, the label for header and footer fields is long and hence we are using this grid size to give more space to the label and avoid text wrapping.
export const gridSize = { lg: 4, md: 6, xs: 12, sm: 6 };

export const gridSizeHeader = { sm: 6, xs: 12 };
export const gridSizeSmall = { sm: 12 };

export const gridSize3Column = { md: 4, sm: 6, xs: 12 };

export const viewMorePopOverGridSize = { md: 8, sm: 8, xs: 12 };

export const BE_ERROR_CODES = {
  CONTACT_EMAIL_ALREADY_IN_USE: "4025",
  CONTACT_UPLOAD_WARNING_CODE: "4072",
  RESTRICT_USER_EDIT_CONTACT_TYPE: "4100",
  PO_BALANCE_EXHAUSTED: "4098",
  PO_NUMBER_UNIQUE: "4054",
  GROUP_NAME_UNIQUE: "4067",
  NEXT_CONTACT_DATE: "4357",
  CONTACT_USED_IN_BILLING: "4068",
  PROGRAM_NAME_UNIQUE: "3064",
  CREATE_GENERIC_ACCOUNT_UNIQUE_NAME: "4174",
  CREATE_GENERIC_ACCOUNT_UNIQUE_REGISTRATION_CODE: "4181",
  VALID_ACCOUNTING_PERIOD_NOT_DEFINED: "4296",
  PO_IS_NOT_MAPPED_TO_PROJECT: "4383",
  OFFICE_HAS_ACTIVE_CHILD_RECORDS: "3144",
  ACTIVITY_ALREADY_IN_USE_PROGRAM_TEMPLATE_ACTIVITY: "3145",
  ACTIVITY_ALREADY_IN_USE_CLIENT_SPECIFIC_ACTIVITY: "4114",
  ACTIVITY_ALREADY_IN_USE_PROJECT_SPECIFIC_ACTIVITY: "4114",
  PROJECT_ALL_CHILD_PROGRAM_STATUS_NOT_CLOSED: "4410",
  PROJECT_ALL_EXPENSE_NOT_BILLED: "4411",
  SEARCH_PROGRAM_LIMIT_EXCEEDED: "4422",
  SEARCH_NIS_PARTICIPANT_LIMIT_EXCEEDED: "9001",
  SEARCH_CLIENT_LIMIT_EXCEEDED: "4124",
  MDM_ACTIVITY_TOPIC_COMBINATION_IN_USE: "3158",
  COACH_PORTAL_SEARCH_PARTICIPANTS_LIMIT_EXCEEDED: "4423",
  PROJECT_SEARCH_LIMIT_EXCEEDED: "4587",
  DUPLICATE_CLIENT_SPECIFIC_ACTIVITY: "4131",
  PURCHASE_ORDER_NUMBER_TAGGED_IN_OTHER_PLACE: "4128",
  COUNSELING_AMOUNT_MUST_BE_GREATER_THAN_ZERO: "4513",
  INVALID_COUNSELING_AMOUNT: "4514",
  OPPORTUNITY_ID_ALREADY_MAPPED_TO_CLIENT: "4149",
  OPPORTUNITY_ID_INVALID_VALIDATE_API: "3160",
  OPPORTUNITY_ID_INVALID: "4146",
  OPPORTUNITY_ID_ALREADY_MAPPED_TO_CLIENT_PROGRAM_MODULE: "4532",
  OPPORTUNITY_ID_ALREADY_MAPPED_TO_PROGRAM: "4159",
  VALIDATE_API_OPPORTUNITY_ID_ALREADY_MAPPED_TO_CLIENT: "3165",
  VALIDATE_API_OPPORTUNITY_ID_ALREADY_MAPPED_TO_PROGRAM: "3166",
  PROGRAM_HAS_UNBILLED_FEES_EXPENSES: "4548",
  PROGRAM_REOPEN_PROJECT_WARNING: "4551",
  INACTIVE_PERIOD_OVERLAPPING: "4604",
  UNMAP_CLIENT_CONTRACT_DOCUMENT_IN_USE_WITH_BILLING_CONFIG: "4166",
  UNMAP_CLIENT_CONTRACT_DOCUMENT_IN_USE_WITH_PROGRAM: "4167",
  CONTACT_ALREADY_IN_USE_BILLING_CONFIG: "4130",
  NIS_PARTICIPANT_DUPLICATE_IN_ACTIVE_PROGRAM: "4558",
  NIS_PARTICIPANT_DUPLICATE_WITH_OPEN_STATUS: 4559, // This is a warning code, not an error code. Hence, it is of type number & not a string.
  USER_SAVED_BUT_CRONOFY_FAILED: 5001, // This is a warning code, not an error code. Hence, it is of type number & not a string.
  CONTACT_ALREADY_MAPPED_TO_PROGRAM_PROJECT: "4187",
  OFFICE_ALREADY_CLASSIFIED_CLIENT: "3182",
  PARENT_CLIENT_ALREADY_IN_USE: "4188",
  MULTIPLE_BILLING_CONFIG_EXISTS_FOR_SAME_PRODUCT_LINE: "4190",
  FORBIDDEN_ERROR_403: 403,
  INVALID_POSTAL_CODE: "4073",
  PROGRAM_TEMPLATE_NEXT_VIEW_NOT_EDITABLE: "3186",
};

export const DEFAULT_ZERO_VALUE_WITH_TWO_DECIMAL = "0.00";

export const MDM_ACTIVITY_SEARCH_TYPE_KEY = {
  all: "All",
  program: "Program",
  project: "Project",
};

export const MDM_ACTIVITY_TYPE_KEY = {
  program: "Program",
  project: "Project",
};

export const INVOICE_HISTORY_SITE_CORE_KEY = {
  statusInvoiced: "Status.Invoiced",
  statusReversed: "Status.Reversed",
};
export const FILE_UPLOAD_ERROR = {
  largerFile: "File is larger than",
  fileType: "File type must be",
};

export const FILE_TYPES = {
  WORD: {
    type: "application/msword",
    extensions: [".doc", ".docx"],
  },
  PDF: {
    type: "application/pdf",
    extensions: [".pdf"],
  },
  EXCEL: {
    type: "application/vnd.ms-excel",
    extensions: [".xls"],
  },
  EXCEL_X: {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    extensions: [".xlsx"],
  },
  TXT: {
    type: "text/plain",
    extensions: [".txt"],
  },
  JPG: {
    type: "image/jpeg",
    extensions: [".jpg", ".jpeg"],
  },
  PNG: {
    type: "image/png",
    extensions: [".png"],
  },
  PPT: {
    type: "application/vnd.ms-powerpoint",
    extensions: [".ppt"],
  },
  PPTX: {
    type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    extensions: [".pptx"],
  },
} as const;

export type FileTypeKey = keyof typeof FILE_TYPES;

export const FILE_TYPE_KEYS = {
  EXCEL: "EXCEL",
  EXCEL_X: "EXCEL_X",
  PDF: "PDF",
  WORD: "WORD",
  TXT: "TXT",
  JPG: "JPG",
  PNG: "PNG",
  PPT: "PPT",
  PPTX: "PPTX",
  DEFAULT: ["EXCEL", "EXCEL_X", "PDF", "WORD"],
} as const;

export type FileTypeKeyLiteral =
  (typeof FILE_TYPE_KEYS)[keyof typeof FILE_TYPE_KEYS];

export const FILE_SIZE_LIMITS = {
  FIFTEEN_MB: 15,
  TEN_MB: 10,
};

export const MEASUREMENT_HALF_DAY_VALUE = "1";
export const EQUAL_TO_FILTER_SITE_CORE_KEY = "FilterBy.EqualTo";

export const ADMIN_USER_GROUPS = {
  G1: "G1",
  G2: "G2",
  G3: "G3",
  G4: "G4",
};

export const ADMIN_ROLE_IDS = {
  COACH: "e1ae1bfe-ae3c-482b-932b-693c95cd113c",
  COACH_ADMIN: "4b74544d-6023-4375-b8bb-d6b39f787dce",
  LEAD_CONSULTANT: "db177056-f035-418e-ad0f-62a9cec4a5c7",
  RESUME_COACH: "97b38b2f-cd64-4779-81ea-bdacec8fe735",
  DELIVERY_COACH: "f3678b21-5c07-4319-a4e8-142aeed9d547",
  TEMPORARY_COACH_HELPDESK: "08c16d83-56ed-43de-9573-c82ac81b9655",
};

export const WEEK_DAYS = [
  {
    label: "Monday",
    value: "monday",
  },
  {
    label: "Tuesday",
    value: "tuesday",
  },
  {
    label: "Wednesday",
    value: "wednesday",
  },
  {
    label: "Thursday",
    value: "thursday",
  },
  {
    label: "Friday",
    value: "friday",
  },
  {
    label: "Saturday",
    value: "saturday",
  },
  {
    label: "Sunday",
    value: "sunday",
  },
];

export const HOURS_LIST = [
  "00:00",
  "00:30",
  "01:00",
  "01:30",
  "02:00",
  "02:30",
  "03:00",
  "03:30",
  "04:00",
  "04:30",
  "05:00",
  "05:30",
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
];

export const INVOICE_REVERSAL_REASON_OTHERS_SITE_CORE_KEY =
  "InvoiceReversalReason.Others";

export const ROLE_IDS = {
  deliverySupport: "86aa60de-e904-4a94-9f5a-01c68516a8d6",
  sales: "702814e7-101f-4f5b-a7a1-10a819348119",
  deliveryCoach: "f3678b21-5c07-4319-a4e8-142aeed9d547",
  clientAccountAdmin: "f49f7717-5bae-4ba4-b069-1fa1502ee88e",
  superAdminClientPortal: "82511c17-b73c-4b9f-b0b2-2794c8425ca9",
  admin: "a88ae2de-3145-4ec5-9bec-28156ab8ec7d",
  enterpriseAdmin: "4ef0de15-50ce-4d09-8931-2cbf13625282",
  superAdmin: "c4876d2c-13a8-4dfd-b58b-34bdacacf5d6",
  projectManager: "3eddeb46-159b-47de-9c4a-34d2963102ff",
  coach: "e1ae1bfe-ae3c-482b-932b-693c95cd113c",
  outreachConsultantLead: "148e7582-e4a7-4e0a-8598-6c371e211fbe",
  billing: "01937658-34b0-44d6-96c8-7306aadeb86f",
  corporateAdmin: "9759922a-83ab-4698-a5a7-7a57bc4b1047",
  clientAccountCoordinator: "9f5b89c1-e57b-4ea1-a2cd-8d481a626ee8",
  projectCoOrdinator: "bedabdb8-17d2-4032-8dde-9a8111cc3dc1",
  clientSubAccountAdmin: "94564334-a8fb-4431-a758-9ee95ddb9908",
  coachAdmin: "4b74544d-6023-4375-b8bb-d6b39f787dce",
  outreachTeam: "2789fc1f-0400-418a-ad72-ec93a268bb64",
  leadConsultant: "DB177056-F035-418E-AD0F-62A9CEC4A5C7",
} as const;

export type AddDeliverableType = "new" | "existing";

export const ADD_DELIVERABLE_TYPE = {
  newKey: "new",
  existingKey: "existing",
};

export const DELIVERABLE_FRAMEWORK_TYPE = {
  PROGRAM: "Program",
  PROJECT: "Project",
};

export const NEXT_PERSONA_TYPE = {
  jobSeeker: "Job Seeker",
  executive: "Executive",
  jobSeekerQuestion: "Common.JobSeekerQuestions",
  executiveQuestion: "Common.ExecutiveQuestions",
};

export const NEXT_QUESTION_IDS = {
  SECTOR_INTEREST: "WhatSectorsAreYouInterestedIn",
  JOB_TYPE_INTEREST: "WhatTypeOfJobsAreyouLookingFor",
};
export const SELECTION_TYPE = {
  multiSelect: "MultiSelect",
};

export const CONTRACT_DOC_TYPE = "contract";

export const WAVE_COHORT_SITE_CORE_KEY = "BatchType.Wave-Cohort";

export const INTAKE_SELECTION_SITE_CORE_KEY_VALUE = {
  bioStatusRequested: "BioStatus.Requested",
  bioStatusPending: "BioStatus.Pending",
  bioStatusBenchSent: "BioStatus.BenchSent",
  bioStatusCoachMatchingStarted: "BioStatus.CoachMatchingStarted",
  bioStatusSentManual: "BioStatus.SentManual",
  intakeStatusDataGatheringNotStarted: "IntakeStatus.DataGatheringNotStarted",
  intakeStatusDataGatheringComplete: "IntakeStatus.DataGatheringComplete",
  intakeStatusDataGatheringInProgress: "IntakeStatus.DataGatheringInProgress",
};

export const ACTIVITY_TIMELINE_TYPE = {
  addActivity: 1,
  participantStatusInactive: 2,
  participantStatusActive: 3,
  participantStatusClosed: 4,
  participantStatusConCon: 5,
  participantTransfer: 6,
  programChange: 7,
  coachAssignment: 8,
  registrationNEXT: 9,
  programClosureSyncNEXT: 10,
  intakeStatus: 11,
  biosStatus: 12,
  chemistryMeetingStatus: 13,
  selectedCoach: 14,
  nisParticipantStatusChanged: 15,
  nisParticipantStatusConverted: 16,
} as const;

export const PENDING_BILLING_REPORT_TYPE_PROGRAM_PROJECT_SITE_CORE_KEY_VALUE = {
  typeProgram: "Type.Program",
  typeProject: "Type.Project",
};

export const PENDING_BILLING_REPORT_TYPE_SITE_CORE_KEY_VALUE = {
  myOffices: "Office.MyOffices",
  includeClosedNo: "IncludeClosed.No",
};

export const CLIENT_TYPE_NON_CLIENT_BILLING_PARTY_SITE_CORE_KEY_VALUE =
  "ClientType.NonClientBillingParty";

export const COACH_METRICS_DATE_RANGE = {
  SIX_MONTH: "Period.Last6Months",
  YEAR_TILL_DATE: "Period.YearTillDate",
  CURRENT_MINUS_ONE_YEAR: "currentMinusOneYear",
  CURRENT_MINUS_TWO_YEAR: "currentMinusTwoYear",
};

export const SummaryStatus = {
  QUEUE: progressStateComponentSiteCoreKeys.inQueueState,
  PROCESSING: progressStateComponentSiteCoreKeys.inProgressState,
  COMPLETED: progressStateComponentSiteCoreKeys.completedState,
  CANCELLED: progressStateComponentSiteCoreKeys.cancelledState,
} as const;

export const BULK_TYPE = {
  ACTIVITY: "Activity",
  PROGRAM: "Program",
  TRANSFER: "Transfer",
} as const;

export const BULK_CATEGORY_FOR_STATUS = {
  bulkActivityProcess: "BulkActivityProcess",
  bulkTransferProcess: "BulkTransferProcess",
} as const;
